var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('img',{staticClass:"logo",attrs:{"src":require("../assets/logo.webp"),"alt":"Logo"},on:{"click":_vm.goHome}})])}
var staticRenderFns = []

export { render, staticRenderFns }